const NAV_ITEMS = [
  { path: '#/dashboard', label: 'Tổng quan', icon: '📊', section: null, roles: ['viewer','data_entry','approver_l1','approver_l2','approver','admin'] },

  // Section: Nhập liệu
  { path: '#/hop-dong', label: 'Hợp đồng', icon: '📄', section: 'Nhập liệu', roles: ['viewer','data_entry','approver_l1','approver_l2','approver','admin'] },
  { path: '#/hd-detail', label: 'Chi tiết HĐ', icon: '🔍', section: 'Nhập liệu', roles: ['viewer','data_entry','approver_l1','approver_l2','approver','admin'] },
  { path: '#/phu-luc', label: 'Phụ lục HĐ', icon: '📎', section: 'Nhập liệu', roles: ['data_entry','approver_l1','approver_l2','approver','admin'] },
  { path: '#/don-hang', label: 'Đơn hàng', icon: '🧾', section: 'Nhập liệu', roles: ['data_entry','approver_l1','approver_l2','approver','admin'] },
  { path: '#/chi-phi', label: 'Ghi nhận trích trước', icon: '📊', section: 'Nhập liệu', roles: ['viewer','data_entry','approver_l1','approver_l2','approver','admin'] },
  { path: '#/pyctt', label: 'Phiếu YCTT', icon: '💸', section: 'Nhập liệu', roles: ['viewer','data_entry','approver_l1','approver_l2','approver','admin'] },
  { path: '#/xuat-kho', label: 'Xuất kho', icon: '📦', section: 'Nhập liệu', roles: ['data_entry','approver_l1','approver_l2','approver','admin'] },

  // Section: Phê duyệt
  { path: '#/approvals', label: 'Phê duyệt', icon: '✔️', section: 'Phê duyệt', roles: ['approver_l1','approver_l2','approver','admin'] },
  { path: '#/quick-approve', label: 'Duyệt nhanh PYC', icon: '⚡', section: 'Phê duyệt', roles: ['approver_l1','approver_l2','approver','admin'] },

  // Section: Dashboards
  { path: '#/ifrs', label: 'IFRS Dashboard', icon: '📈', section: 'Dashboards', roles: ['approver_l1','approver_l2','approver','admin'] },
  { path: '#/fpa', label: 'FP&A Dashboard', icon: '📊', section: 'Dashboards', roles: ['approver_l1','approver_l2','approver','admin'] },

  // ───── v29: BOD Dashboards V2 (focus 5 trang) ─────
  { path: '#/bod/v2/health',   label: 'Executive Summary',     icon: '💹', section: 'BOD Dashboards', roles: ['approver_l2','approver','admin','bod'] },
  { path: '#/bod/v2/pnl',      label: 'P&L Deep Dive',  icon: '📈', section: 'BOD Dashboards', roles: ['approver_l2','approver','admin','bod'] },
  { path: '#/bod/v2/cash',     label: 'Cash & Liquidity', icon: '💵', section: 'BOD Dashboards', roles: ['approver_l2','approver','admin','bod'] },
  { path: '#/bod/v2/crisis',   label: 'Crisis Room',     icon: '🚨', section: 'BOD Dashboards', roles: ['approver_l2','approver','admin','bod'] },
  { path: '#/bod/v2/strategy', label: 'Strategy',        icon: '🎯', section: 'BOD Dashboards', roles: ['approver_l2','approver','admin','bod'] },

  // v30.10: Removed BOD Legacy section (7 items deleted in audit cleanup)

  // Section: Báo cáo tài chính
  { path: '#/baocao/pl-ifrs', label: 'P&L theo IFRS', icon: '📋', section: 'Báo cáo tài chính', roles: ['approver_l2','approver','admin','bod'] },

  { path: '#/kho', label: 'Tồn kho', icon: '🏭', section: 'Dashboards', roles: ['viewer','data_entry','approver_l1','approver_l2','approver','admin'] },
  { path: '#/prepaid', label: 'CP Chờ Phân Bổ', icon: '⏳', section: 'Dashboards', roles: ['data_entry','approver_l1','approver_l2','approver','admin'] },

  // Section: Quản lý
  { path: '#/doanh-so', label: 'Doanh số', icon: '💹', section: 'Quản lý', roles: ['approver_l1','approver_l2','approver','admin'] },
  { path: '#/ngan-sach', label: 'Ngân sách', icon: '📊', section: 'Quản lý', roles: ['approver_l1','approver_l2','approver','admin'] },
  { path: '#/du-an', label: 'Dự án', icon: '🏗️', section: 'Quản lý', roles: ['approver_l1','approver_l2','approver','admin'] },

  // Section: Quản trị
  { path: '#/admin', label: 'Admin Panel', icon: '⚙️', section: 'Quản trị', roles: ['admin'] }
];

export function renderSidebar(user) {
  const items = NAV_ITEMS.filter(item => item.roles === '*' || item.roles.includes(user.role));
  const sections = {};
  items.forEach(item => {
    const sec = item.section || '_top';
    if (!sections[sec]) sections[sec] = [];
    sections[sec].push(item);
  });

  let html = '';
  if (sections._top) html += sections._top.map(renderNavItem).join('');
  Object.keys(sections).filter(s => s !== '_top').forEach(sec => {
    html += `<div class="nav-section">${sec}</div>`;
    html += sections[sec].map(renderNavItem).join('');
  });

  // Project picker
  const projects = user.myProjects || [];
  const current = user.currentProject || '';
  let projHtml = '';
  if (projects.length > 0 || user.role === 'admin' || user.role?.startsWith('approver')) {
    const canSwitch = projects.length > 1 || user.role === 'admin' || user.role?.startsWith('approver');
    const label = current ? (projects.find(p => p.ma_da === current)?.ma_da || current) : 'Tất cả dự án';
    const tenDa = current ? (projects.find(p => p.ma_da === current)?.ten_da || '') : '';
    projHtml = `
      <div class="sb-project-picker" id="sb-proj">
        <div class="sb-proj-label">🏗 DỰ ÁN HIỆN TẠI</div>
        <div class="sb-proj-current" ${canSwitch ? 'data-clickable="1"' : ''}>
          <div class="sb-proj-ma">${label}</div>
          ${tenDa ? `<div class="sb-proj-ten">${tenDa}</div>` : ''}
          ${canSwitch ? '<div class="sb-proj-caret">▾</div>' : ''}
        </div>
        ${canSwitch ? '<div class="sb-proj-dropdown" id="sb-proj-dropdown" style="display:none"></div>' : ''}
      </div>`;
  }

  // v28c: Branding khác cho role BOD
  const isBOD = user.role === 'bod';
  const brandTitle = isBOD ? 'BOD VINAENC' : 'VNEC v9';
  const brandSub = isBOD ? 'Board of Directors' : 'VINAENC ERP';

  return `
    <aside class="sidebar">
      <div class="sidebar-brand" style="display:flex;align-items:center;justify-content:space-between">
        <div>
          <div class="brand-title">${brandTitle}</div>
          <div class="brand-sub">${brandSub}</div>
        </div>
        <div id="sb-bell-mount"></div>
      </div>
      ${projHtml}
      <nav class="sidebar-nav">${html}</nav>
      <div class="sidebar-footer">
        <div class="user-info">
          <div class="user-name">${user.name || user.email}</div>
          <div class="user-email">${user.email}</div>
          <div class="user-role">${roleLabel(user.role)}</div>
        </div>
        <button class="btn btn-ghost btn-sm btn-block" id="btn-logout">Đăng xuất</button>
      </div>
    </aside>`;
}

// v28c: Friendly role labels
function roleLabel(role) {
  const labels = {
    'admin': 'Quản trị',
    'approver': 'Phê duyệt',
    'approver_l1': 'Duyệt L1',
    'approver_l2': 'Duyệt L2',
    'data_entry': 'Nhập liệu',
    'viewer': 'Xem',
    'bod': 'Ban Lãnh Đạo'
  };
  return labels[role] || role;
}

function renderNavItem(item) {
  return `<a href="${item.path}" class="nav-item" data-path="${item.path}">
    <span class="nav-icon">${item.icon}</span>
    <span class="nav-label">${item.label}</span>
  </a>`;
}

export function highlightActiveNav() {
  const current = window.location.hash || '#/dashboard';
  document.querySelectorAll('.nav-item').forEach(el => {
    el.classList.toggle('active', current.startsWith(el.dataset.path));
  });
  wireProjectPicker();
  mountBell();
}

async function mountBell() {
  const slot = document.getElementById('sb-bell-mount');
  if (!slot || slot.dataset.mounted) return;
  slot.dataset.mounted = '1';
  try {
    const { mountBellIcon } = await import('./notifications-panel.js');
    mountBellIcon(slot);
  } catch (e) { console.error('[mountBell]', e); }
}

async function wireProjectPicker() {
  const pp = document.getElementById('sb-proj');
  if (!pp) return;
  const currentEl = pp.querySelector('.sb-proj-current[data-clickable]');
  if (!currentEl) return;
  const dropdown = document.getElementById('sb-proj-dropdown');
  if (!dropdown) return;

  const { getMyProjects, setCurrentProject, getCurrentProject } = await import('../lib/session.js');

  currentEl.addEventListener('click', async () => {
    if (dropdown.style.display === 'block') {
      dropdown.style.display = 'none';
      return;
    }
    dropdown.innerHTML = '<div class="sb-proj-loading">Đang tải...</div>';
    dropdown.style.display = 'block';
    try {
      const [projects, current] = await Promise.all([getMyProjects(), getCurrentProject()]);
      const user = await import('../lib/supabase.js').then(m => m.getCurrentUser());
      const isPriv = user && (user.role === 'admin' || (user.role || '').startsWith('approver'));
      let html = '';
      if (isPriv) {
        html += `<div class="sb-proj-item ${!current ? 'active' : ''}" data-ma="__ALL__">🌐 Tất cả dự án</div>`;
      }
      projects.forEach(p => {
        html += `<div class="sb-proj-item ${p.ma_da === current ? 'active' : ''}" data-ma="${p.ma_da}">
          <div class="sb-proj-item-ma">${p.ma_da}${p.is_default ? ' ⭐' : ''}</div>
          <div class="sb-proj-item-ten">${p.ten_da || ''}</div>
        </div>`;
      });
      dropdown.innerHTML = html || '<div class="sb-proj-loading">Không có dự án</div>';
      dropdown.querySelectorAll('.sb-proj-item').forEach(el => {
        el.addEventListener('click', async () => {
          const ma = el.dataset.ma === '__ALL__' ? null : el.dataset.ma;
          try {
            await setCurrentProject(ma);
            window.location.reload();
          } catch (e) { alert('Lỗi: ' + e.message); }
        });
      });
    } catch (e) {
      dropdown.innerHTML = `<div class="sb-proj-loading" style="color:#A8000A">Lỗi: ${e.message}</div>`;
    }
  });

  document.addEventListener('click', (e) => {
    if (!pp.contains(e.target)) dropdown.style.display = 'none';
  });
}
